/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 16/03/2025 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import { useConfiguracion } from "../../context/System/ConfiguracionContext"
import { Dialog, DialogContent, DialogActions, Button, AppBar, Toolbar, Typography } from "@mui/material";
import { useEffect, useRef } from "react";

export default function SizeSoftXConfirmDialog(props) {
    const { open = false, title, message, handleConfirmDialog, colorTitle } = props;
    const { theme } = useConfiguracion();
    const confirmButtonRef = useRef(null);

    const handleConfirmar = () => {
        if (handleConfirmDialog) {
            handleConfirmDialog(true);
        }
    };

    const handleCancelar = () => {
        if (handleConfirmDialog) {
            handleConfirmDialog(false);
        }
    };

    useEffect(() => {
        if (open) {
            requestAnimationFrame(() => {
                if (confirmButtonRef.current) {
                    confirmButtonRef.current.focus();
                }
            });
        }
    }, [open]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleConfirmar();
        }
    };

    const bgColor = colorTitle || theme.palette.orange.main;

    return (
        <Dialog open={open} onClose={handleCancelar} maxWidth="sm" fullWidth onKeyDown={handleKeyDown}>
            <AppBar position="static" color="primary">
                <Toolbar sx={{textAlign: "center", backgroundColor: bgColor}}>
                    <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent>
                <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button ref={confirmButtonRef} variant="contained" color="primary" onClick={handleConfirmar}>
                    Aceptar
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleCancelar}>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

